import { usePayrollPrices } from '@/features/payroll/payrollPrice.hooks'
import { useNewCatalogSignup } from '../plans/useNewCatalogSignup'
import { CatalogPayment } from './CatalogPayment'
import { LegacyPayment } from './LegacyPayment'

/** Mounts neither screen until the flag resolves. */
export const Payment = ({ isUpsell }: { isUpsell?: boolean }) => {
  const catalog = useNewCatalogSignup()
  usePayrollPrices()
  if (catalog === null) return null
  return catalog ? (
    <CatalogPayment isUpsell={isUpsell} />
  ) : (
    <LegacyPayment isUpsell={isUpsell} />
  )
}
